export default "__VITE_ASSET__DTs5pmAd__"